/* eslint-disable prettier/prettier */
import { WithChildrenProps } from '@app/types/generalTypes';
/* eslint-disable prettier/prettier */
import React from 'react';
import { Helmet } from 'react-helmet-async';

export const PageTitle: React.FC<WithChildrenProps> = ({ children }) => {
  return (
    <Helmet>
      <title>{children} | Mobile Device Management </title>
    </Helmet>
  );
};
